export const formName = 'add-voucher-form';
export const billPayerTypeRelation = 'RELATION';
export const billPayerTypeCompany = 'COMPANY';
